class IndcomFacilitySelfInspectionConfirmationModal {
  static formKey = "indcom-facility-self-inspection-confirmation";
  static $modal = $("#assessment-modal");
  static initialData;

  static async show() {
    IndcomFacilitySelfInspectionConfirmationModal.initialData =
      await PortalApiCalls.getIndcomFacilitySelfInspectionProject();

    IndcomFacilitySelfInspectionConfirmationModal.#loadDomListeners();
    IndcomFacilitySelfInspectionConfirmationModal.#render();
    Form.initializeAndLoadListeners(
      IndcomFacilitySelfInspectionConfirmationModal.$modal,
      IndcomFacilitySelfInspectionConfirmationModal.formKey,
    );

    Analytics.sendScreenView("portal", IndcomFacilitySelfInspectionConfirmationModal.formKey);
  }

  static #loadDomListeners() {
    IndcomFacilitySelfInspectionConfirmationModal.$modal.on(
      "click",
      ".save-button",
      IndcomFacilitySelfInspectionConfirmationModal._save,
    );
    IndcomFacilitySelfInspectionConfirmationModal.$modal.on(
      "2N:FormInput",
      IndcomFacilitySelfInspectionConfirmationModal.#checkEnableSaveButton,
    );
    IndcomFacilitySelfInspectionConfirmationModal.$modal.on(
      "click",
      ".js-download-pdf",
      IndcomFacilitySelfInspectionConfirmationModal._downloadPdf,
    );
  }

  static #unloadDomListeners() {
    IndcomFacilitySelfInspectionConfirmationModal.$modal.off(
      "click",
      ".save-button",
      IndcomFacilitySelfInspectionConfirmationModal._save,
    );
    IndcomFacilitySelfInspectionConfirmationModal.$modal.off(
      "2N:FormInput",
      IndcomFacilitySelfInspectionConfirmationModal.#checkEnableSaveButton,
    );
    IndcomFacilitySelfInspectionConfirmationModal.$modal.off(
      "click",
      ".js-download-pdf",
      IndcomFacilitySelfInspectionConfirmationModal._downloadPdf,
    );
  }

  static #checkEnableSaveButton() {
    const canSaveLetter = IndcomFacilitySelfInspectionConfirmationModal._hasAllRequiredFields();
    IndcomFacilitySelfInspectionConfirmationModal.$modal
      .find(".save-button")
      .toggleClass("disabled", !canSaveLetter);
  }

  static #render() {
    const html = nunjucks.render("modals/portal/selfInspectionConfirmation.njk", {
      initialData: IndcomFacilitySelfInspectionConfirmationModal.initialData,
      showEmailOptIn: false,
    });
    IndcomFacilitySelfInspectionConfirmationModal.$modal.html(html);
    IndcomFacilitySelfInspectionConfirmationModal.$modal.modal("show");
  }

  static #getUpdateData(updateData) {
    return {
      updates: updateData,
    };
  }

  static async _save() {
    await Form.getReadyToSavePromise(IndcomFacilitySelfInspectionConfirmationModal.formKey);
    const updateData = IndcomFacilitySelfInspectionConfirmationModal.#getUpdateData(
      Form.getDataFromForm(IndcomFacilitySelfInspectionConfirmationModal.formKey, false),
    );
    await PortalApiCalls.saveIndcomFacilitySelfInspectionConfirmation(updateData);
    MessageModal.showCustomMessage(
      "Success",
      `A confirmation email has been sent to you at ${updateData.updates.email}! You may now close this browser tab.`,
      { primaryButtonText: "Close" },
    );
  }

  static close() {
    Form.clearForm(IndcomFacilitySelfInspectionConfirmationModal.formKey);
    IndcomFacilitySelfInspectionConfirmationModal.#unloadDomListeners();
    IndcomFacilitySelfInspectionConfirmationModal.$modal.modal("hide");
  }

  static _hasAllRequiredFields() {
    let requiredFilled = 0;
    const requiredFields = ["email"];
    const data = Form.getDataFromForm(IndcomFacilitySelfInspectionConfirmationModal.formKey, false);

    for (const key in data) {
      if (requiredFields.includes(key) && !!data[key]) {
        requiredFilled++;
      }
    }

    const isValidEmail = IndcomFacilitySelfInspectionConfirmationModal.$modal
      .find(`[name="email"]`)[0]
      .checkValidity();

    return requiredFilled === requiredFields.length && isValidEmail;
  }

  static _downloadPdf() {
    return PortalApiCalls.downloadIndcomFacilitySelfInspectionPdf();
  }
}

module.exports = IndcomFacilitySelfInspectionConfirmationModal;

const Analytics = require("../../general/analytics");
const PortalApiCalls = require("../portalApiCalls");
const Form = require("../../general/form");
const MessageModal = require("../../modals/messageModal");
